import { useSelector } from 'react-redux';
import { useMemo } from 'react';

import safeSum from '../../../../../../utils/safeSum';

const useMessageOptions = ({ disabledIds = [] }) => {
  const messages = useSelector((state) => state.resonance.messages);

  const formattedOptions = useMemo(
    () =>
      (messages ?? []).map((message) => ({
        label: message.message,
        value: message.id,
        disabled: disabledIds.includes(message.id),
        calculations: {
          r1: message.r1Total,
          r2: message.r2Total,
          total: safeSum(message.accurateR1Total, message.accurateR2Total),
        },
      })),
    [messages, disabledIds],
  );

  return formattedOptions;
};

export default useMessageOptions;
